export enum LogoutReason {
  SignInErrorUnknown = 'SignInErrorUnknown',
  SignInFailedToInitializeApp = 'SignInFailedToInitializeApp',
  ConsentFirstLoginMissing = 'ConsentFirstLoginMissing',
  ConsentFirstLoginRejected = 'ConsentFirstLoginRejected',
  SSOAuthError = 'SSOAuthError',
  TokenExpired = 'TokenExpired',
  InactivityTimeout = 'InactivityTimeout',
  SSOCallbackError = 'SSOCallbackError',
  ErrorWhileSavingConsent = 'ErrorWhileSavingConsent',
  OtherInstanceLoggedOut = 'OtherInstanceLoggedOut',
  UserDisabled = 'UserDisabled',
  NetworkError = 'NetworkError',
  BiometricAuthenticationFailed = 'BiometricAuthenticationFailed',
  BiometricTooManyAttempts = 'BiometricTooManyAttempts',
  BiometricFingerprintChanged = 'BiometricFingerprintChanged',
  BiometricNotAvailableTimeout = 'BiometricNotAvailableTimeout',
  BiometricSecurityUpdateRequired = 'BiometricSecurityUpdateRequired',
  PinLocked = 'PinLocked',
  PinForgotten = 'PinForgotten',
}
